import './ManagerModule';

function importAll(r) {
	r.keys().forEach(r);
}

importAll(
	require.context("./", true, /^.*\.js$/)
);

export default angular.module("manager");